import ServicesPage from './ServicesPage';

export default ServicesPage;
